import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  AccountMoveModel,
  AccountMoveOwnerContext,
  AccountMoveTabOptions,
} from '../../../../../../shared/store/accounting/types';
import { InsuranceClaimService } from '../../../../../../shared/store/insurance-claim/insurance-claim.service';
import { filterTrue } from '../../../../../../shared/pipe/rxjs/operators';

/**
 * Enveloppe sinistre de {@link AccountMovesTabComponent}.
 *
 * L'onglet est instancié par `*ngComponentOutlet` sans binding : le composant résout donc lui-même le
 * sinistre courant depuis le store, comme les autres onglets de la fiche sinistre.
 */
@UntilDestroy()
@Component({
  selector: 'app-insurance-claim-details-account-moves',
  standalone: false,
  templateUrl: './insurance-claim-details-account-moves.component.html',
  styleUrl: './insurance-claim-details-account-moves.component.scss',
})
export class InsuranceClaimDetailsAccountMovesComponent implements OnInit {
  accountMoves: AccountMoveModel[] = [];
  context: AccountMoveOwnerContext;
  tabOptions: AccountMoveTabOptions = {};

  constructor(
    private readonly insuranceClaimService: InsuranceClaimService,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.insuranceClaimService.getByUniqueId.value$
      .pipe(filterTrue(), untilDestroyed(this))
      .subscribe((insuranceClaim) => {
        this.accountMoves = insuranceClaim.clientAccountMoves ?? [];

        const insuranceCompanyContactId =
          insuranceClaim.contractProductProductLineInsuranceCompanyContactId;

        //champs et pas getter : un getter reconstruirait le contexte à chaque détection de changement.
        this.context = {
          ownerType: 'InsuranceClaim',
          contractId: insuranceClaim.contractId,
          contactId: insuranceClaim.contactId,
          insuranceClaimId: insuranceClaim.id,
          insuranceCompanyContactId: insuranceCompanyContactId,
        };

        //sans compagnie d'assurance, les modales de quittance n'ont pas de domaine de comptes à
        //proposer : on masque la création plutôt que d'ouvrir une modale vide sans explication.
        this.tabOptions = {
          showAddInvoice: !!insuranceCompanyContactId,
        };
      });
  }

  onRefresh(): void {
    this.insuranceClaimService.getByUniqueId.call(
      this.route.snapshot.params['uniqueId'],
    );
  }
}
